<template>
  <div class="container">
        <div class="modal-content">
          <div class="modal-body">
            <div style="margin:20px 0;text-align:center;font-size:32px;"><strong>{{ info.title }}</strong></div>
            <div class="product-title-dec">{{ info.describe }}</div>
            <div class="selectedProduct-box"></div>
            <div v-html="info.content" class="news-box">
            </div>

            <!-- <div class="news-box-img">
            <img src="../assets/img/newdetail1.png"/>
            </div>

            <div class="news-box-img">
            <img src="../assets/img/newdetail2.png"/>
            </div>

            <div class="news-box">
            <strong>{{ $t('newsdetailone.highlight') }}</strong>
            </div>

            <div class="news-box">
            {{ $t('newsdetailone.description') }}
            </div> -->

          </div>
        </div>

  </div>
</template>

<script>
import request from '@/utils/request'
export default {
  data(){
    return {
      info:{},
      parentId:'',
      languageId:null
    }
  },
  methods:{
    getDetail(){
      request.get(`/hkbr/news/info/${this.parentId}/${this.languageId}`).then(res=>{
        this.info = res.data
      })
    }
  },
  created(){
    let parentId = this.$route.query.parentId
    this.parentId = parentId
    this.languageId = this.$route.query.languageId
    this.getDetail()
  },
  // watch:{
  //   '$store.state.lang':{
  //     handler:function(val){
  //       console.log(val,this.$store.state.lang,'[o-----------]')
  //     },
  //     immediate:true
  //   }
  // }
}
</script>

<style scoped>
.container{
    width: 100%;

}
.modal-content {
  background: #fff;
  padding: 20px;
  width: 1200px;
  /* position: relative; */
  /* border-radius: 5px;
   */
   margin:auto;
}

.product-title-dec {
  background: #f6f6f6;
  color: #4a4a4a;
  font-size: 24px;
  padding: 10px 20px;
  box-sizing: border-box;
  text-align: center;
  margin-bottom: 20px;
}
</style>
<style>
.modal-content img{
  max-width: 1000px;
  height: auto;
  display: block;
  margin:0 auto;
}
</style>